import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import { buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import { IAPICreateContactModel } from "../interfaces/IAPIContactModels";
import { IAPIGetListInterestTagResponseModel } from "../interfaces/IAPIListInterestTagModel";
import { CreateProductResponse } from "../models";

class ListInterestTagService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  getMindMeListInterestTag(
    accountId: string
  ): Observable<IAPIResponse<IAPIGetListInterestTagResponseModel>> {
    const params: string = buildParamString({
      accountId: accountId,
    });
    return this.httpService.get<
      IAPIResponse<IAPIGetListInterestTagResponseModel>
    >(url.getMindMeListInterestTag, params);
  }

  create(
    accountId: string,
    name: string,
    type: string
  ): Observable<IAPIResponse<CreateProductResponse>> {
    const params: string = buildParamString({
      accountId: accountId,
      name: name,
      type: type,
    });
    return this.httpService.get<IAPIResponse<CreateProductResponse>>(
      url.createListInterestTag,
      params
    );
  }
}
export default new ListInterestTagService();
